export const getSizeAsNumber = size => {
  return Number(size.replaceAll(/\D/g, ""))
}
